import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import authService from '../services/api/authService';
import Logo from './Logo';
import '../assets/styles/auth.css';
import showToast from '../utils/toastHelper';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsSubmitting(true);

    try {
      await authService.forgotPassword(email);
      setIsSuccess(true);
      showToast('Password reset link sent to your email!', 'success');
    } catch (err) {
      const message = err.response?.data?.error || 'Failed to send reset link. Please try again.';
      showToast(message, 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="form-body-single">
      <div className="bg-shape bg-shape-1"></div>
      <div className="bg-shape bg-shape-2"></div>
      <div className="bg-shape bg-shape-3"></div>
      <div className="form-content-centered">
        <div style={{ marginBottom: '2rem' }}>
          <Logo color="white" width="300px" />
        </div>
        <div className="form-items">
          <h3 className="font-md">Forgot Password</h3>
          <p>Enter your email address and we'll send you a link to reset your password.</p>

          {isSuccess ? (
            <div className="success-message">
              <strong>Check your email!</strong>
              <p className="mb-0 mt-2">We've sent a password reset link to <strong>{email}</strong></p>
            </div>
          ) : (
            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Email Address</label>
                <input
                  className="form-control"
                  type="email"
                  placeholder="Enter your email address"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  disabled={isSubmitting}
                />
              </div>

              <button type="submit" className="btn btn-primary" disabled={isSubmitting}>
                {isSubmitting ? 'Sending...' : 'Send Reset Link'}
              </button>
            </form>
          )}

          <div className="page-links">
            <Link to="/login">Back to Sign In</Link>
          </div>
        </div>
      </div>

      <footer className="auth-footer">
        <div>© 2025. VoteWave.</div>
        <div>
          <Link to="/terms-and-conditions">Terms & Conditions</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
        </div>
      </footer>
    </div>
  );
};

export default ForgotPassword;
